"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext, useRef, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import { isValidImageType } from "./imageValidation";
interface UseImageUploadOptions {
  maxSizeBytes: number;
  maxSizeLabel: string;
  setFile: (file: File) => void;
}
export function useImageUpload(t0) {
  const $ = _c(17);
  const {
    maxSizeBytes,
    maxSizeLabel,
    setFile
  } = t0;
  const {
    setToast
  } = useContext(AuthContext);
  const dragDepth = useRef(0);
  const [error, setError] = useState(null);
  const [shake, setShake] = useState(false);
  const [dragging, setDragging] = useState(false);
  let t1;
  if ($[0] !== maxSizeBytes || $[1] !== maxSizeLabel || $[2] !== setFile || $[3] !== setToast) {
    t1 = file => {
      setError(null);
      if (!isValidImageType(file)) {
        setToast({
          type: "error",
          message: "Invalid file type"
        });
        return;
      }
      if (file.size > maxSizeBytes) {
        setError(`File size must be less than ${maxSizeLabel}`);
        setShake(true);
        setTimeout(() => setShake(false), 300);
        return;
      }
      setFile(file);
    };
    $[0] = maxSizeBytes;
    $[1] = maxSizeLabel;
    $[2] = setFile;
    $[3] = setToast;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onFileChange = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.preventDefault();
      e.stopPropagation();
      dragDepth.current = dragDepth.current + 1;
      setDragging(true);
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onDragEnter = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      dragDepth.current = dragDepth.current - 1;
      if (dragDepth.current <= 0) {
        dragDepth.current = 0;
        setDragging(false);
      }
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onDragLeave = t3;
  const onDragOver = _temp;
  let t4;
  if ($[7] !== onFileChange) {
    t4 = e_2 => {
      e_2.preventDefault();
      e_2.stopPropagation();
      dragDepth.current = 0;
      setDragging(false);
      const file_0 = e_2.dataTransfer.files[0];
      if (file_0) {
        onFileChange(file_0);
      }
    };
    $[7] = onFileChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onDrop = t4;
  let t5;
  if ($[9] !== onDrop) {
    t5 = {
      onDrop,
      onDragEnter,
      onDragLeave,
      onDragOver
    };
    $[9] = onDrop;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dragging || $[12] !== error || $[13] !== onFileChange || $[14] !== shake || $[15] !== t5) {
    t6 = {
      error,
      shake,
      dragging,
      onFileChange,
      dragHandlers: t5
    };
    $[11] = dragging;
    $[12] = error;
    $[13] = onFileChange;
    $[14] = shake;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(e_1) {
  e_1.preventDefault();
  e_1.stopPropagation();
}